module.exports = __webpack_public_path__ + "img/16_20_bg.e799e489.png";